import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import DashboardHome from "./DashboardHome";

import Centres from "./Centres";
import Machines from "./Machines";
import Userdata from "./Userdata";
import Projects from "./Projects";
import Supportdashboard from "./Supportdashboard";

import ExpertsManagement from "./ExpertsManagement";
import PromotionsDashboard from "./PromotionsDashboard";
import CentresAnalytics from "./CentresAnalytics";
import Enquiries from "./Enquiries";
import Orderspage from "./Orderspage";
import Repportsanylisis from './Repportsanylisis';
import FacilitiesManagement from './FacilitiesManagement';
import Profilemangement from './Profilemangement';
import Teammanagement from './Teammanagement';
import Registration  from './Registration';
import Payments from './Payments';
import Erpdashbord from './Erpdashbord';
import Inventry from './Inventry'
import Maintance from './Maintance'
import Quilty from './Quilty'
// import Salesdata from "./Salesdata";
// import Quotations from "./Quotations";
// import Orders from "./Orders";
// import Billing from "./Billing";
// import Payments from "./Payments";
import Operatorsvendor from "./Operatorsvendor";
// import Experts from "./Experts";
// import Inventory from "./Inventory";
// import Maintenance from "./Maintenance";
// import Quality from "./Quality";
// import Logistics from "./Logistics";

export default function VendorDashboard() {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                basePath="/vendor"
            />

            <div style={{backgroundColor:"white"}} className="flex-1 flex flex-col overflow-hidden">
                <Topbar collapsed={collapsed} setCollapsed={setCollapsed} />

                {/* VendorDashboard is mounted at "/vendordashboard/*" in App.jsx,
                    so these paths are relative to "/vendordashboard" */}
                <Routes>
                    <Route index element={<DashboardHome />} />
                    <Route path="centres" element={<Centres />} />
                    <Route path="machines" element={<Machines />} />
                    <Route path="bookings" element={<Centres />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="quotations" element={<Centres />} />
                    <Route path="billing" element={<Centres />} />
                    {/* <Route path="payments" element={<Centres />} /> */}
                    <Route path="operators" element={<Centres />} />
                    <Route path="experts" element={<Centres />} />
                    <Route path="inventory" element={<Centres />} />
                    <Route path="maintenance" element={<Centres />} />
                    <Route path="quality" element={<Centres />} />
                    <Route path="logistics" element={<Centres />} />
                    <Route path="support" element={<Supportdashboard />} />
                    <Route path="userdata" element={<Userdata />} />
                    <Route path="expertsmanagement" element={<ExpertsManagement />} />
                    <Route path="promotionsdashboard" element={<PromotionsDashboard />} />
                    <Route path="centresanalytics" element={<CentresAnalytics />} />
                    <Route path="enquiries" element={<Enquiries />} />
                    <Route path="orderspage" element={<Orderspage />} />
                    <Route path="/Repportsanylisis"element={<Repportsanylisis/>}/>
                    <Route path="/FacilitiesManagement"element={<FacilitiesManagement/>}/>
                    <Route path="/Profilemangement"element={<Profilemangement/>}/>
                    <Route path="/Teammanagement"element={<Teammanagement/>}/>
                    <Route path="Registration"element={<Registration />}/>
                    <Route path="/Payments" element={<Payments/>}/>
                    <Route path="/Erpdashbord"element={<Erpdashbord/>}/>
                    <Route path="/Operatorsvendor"element={<Operatorsvendor/>}/>
                    <Route path="/Inventry"element={<Inventry/>}/>
                     <Route path="/Maintance"element={<Maintance/>}/>
                     <Route path="/Quilty"element={<Quilty/>}/>
                     

                    

                    

                    {/* <Route path="salesdata" element={<Salesdata />} /> */}
                </Routes>
            </div>
        </div>
    );
}